import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import persist from "@alpinejs/persist";
import searchApp from "./searchApp";
import favorites from "./favorites";
import favoritesPage from "./favoritesPage";
import resumeBuilder from "./resumeBuilder";
import { setupQuill } from "./quill-setup";
import { initObservability } from "./observability";

Alpine.plugin(intersect);
Alpine.plugin(persist);

initObservability();

(window as any).setupQuill = setupQuill;

Alpine.store("favorites", favorites);
Alpine.data("searchApp", searchApp);
Alpine.data("favoritesPage", favoritesPage);
Alpine.data("resumeBuilder", resumeBuilder);

window.Alpine = Alpine;

Alpine.start();
